import PatientAccount from './PatientAccount';

export default PatientAccount;
